<template>
  <div class="h5-share-wrapper">
    <Menu :items="menus" @on-change-menu="onChangeMenu" />

    <section class="poster" v-show="menus[0].active" v-if="isShowPoster">
      <div class="header">
        <label class="title">分享海报</label>
        <p class="tip">请在您的公众号中将此链接设置为关键词<br />【听课】的自动回复内容。裂变出的用户将<br />通过此链接到您的公众号领取课程。</p>
      </div>

      <canvas id="canvas" class="canvas">抱歉，您的浏览器不支持canvas元素</canvas>
      <img class="poster-image" :src="posterURL" />
    </section>

    <section class="link" v-show="menus[1].active">
      <div class="header">
        <label class="title">课程链接</label>
        <p class="tip">请在您的公众号中将此链接设置为关键词<br />【听课】的自动回复内容。裂变出的用户将<br />通过此链接到您的公众号领取课程。</p>
      </div>

      <div class="copy">
        <div class="link">{{link}}</div>
        <span class="btn" @click="copy">复制</span>
      </div>
    </section>
  </div>
</template>

<script>
import Notes from '@/engine/Notes'
import { utils } from '@/util/index'

import Menu from '@/components/h5/Menu.vue'

const drawPoster = (vm, image, qrUrl) => {
  const canvas = document.getElementById('canvas')
  canvas.width = 480
  canvas.height = 800
  if (canvas && canvas.getContext) {
    const ctx = canvas.getContext('2d')
    const img = new Image()
    img.setAttribute('crossOrigin', 'Anonymous')
    img.src = image
    img.onload = () => {
      ctx.drawImage(img, 0, 0)

      const qr = new Image()
      qr.setAttribute('crossOrigin', 'Anonymous')
      qr.src = qrUrl
      qr.onload = () => {
        ctx.drawImage(qr, 318, 653, 130, 130)

        try {
          vm.posterURL = canvas.toDataURL('image/png')
        } catch (error) {
          console.error(JSON.stringify(error))
        }
      }
    }
  }
}

export default {
  name: 'h5Share',
  components: {
    Menu,
  },
  data () {
    return {
      menus: [{
        id: 'poster',
        name: '分享海报',
        active: true,
      }, {
        id: 'link',
        name: '分享链接',
        active: false,
      }],
      isShowPoster: true,
      link: '',
      posterURL: '',
    }
  },
  mounted () {
    this.globalData.selectedChannel = 'test'
    const { id: classId } = utils.formatQuery(this.$route.query)
    Notes.generateQrCode({
      appId: this.globalData.appId,
      channel: this.globalData.selectedChannel || 'nature',
      level: 0,
      classId,
      shareType: 'customer',
    }).then(async ({ url }) => {
      this.link = `${process.env.VUE_APP_H5_DOMAIN}/?appId=${this.globalData.appId}&qr=${encodeURIComponent(url)}`

      const { circleShares } = await Notes.fetchConfig()
      if (circleShares && circleShares[classId] && circleShares[classId].image) {
        this.menus[0].hide = false
        this.menus[0].active = true
        this.menus[1].active = false
        drawPoster(this, circleShares[classId].image, url)
      } else {
        this.isShowPoster = false
        this.menus[0].hide = true
        this.menus[1].active = true
      }
    })
  },
  methods: {
    onChangeMenu: function (id) {
      this.menus = this.menus.map((item, index) => {
        if (item.id === id) {
          this.menuActiveIndex = index
        }
        return {
          ...item,
          active: item.id === id,
        }
      })
    },
    copy: function () {
      this.$copyText(this.link).then(() => {
        this.$toast('链接复制成功')
      }, () => {
        this.$toast('链接复制失败，请刷新后重试！')
      })
    },
  },
};
</script>

<style lang="scss">
.h5-share-wrapper {
  .menu-wrapper .menu-list {
    display: flex;
    justify-content: space-around;
  }

  .header {
    margin: 50px 0 25px;
    color: #e51c23;
    text-align: center;

    .title {
      display: inline-block;
      font-size: 28px;
      font-weight: bold;
      line-height: 42px;
      padding-left: 40px;
      margin-bottom: 10px;
      background-image: url('../../../assets/h5/poster.png');
      background-size: 30px;
      background-repeat: no-repeat;
      background-position: left center;
    }

    .tip {
      padding: 0;
      margin: 0;
      font-size: 14px;
      line-height: 21px;
    }
  }

  .link .title {
    background-image: url('../../../assets/h5/link.png') !important;
  }

  .copy {
    text-align: center;

    .link {
      display: flex;
      width: 90vw;
      min-height: 60px;
      align-items: center;
      justify-content: center;
      padding: 10px 20px;
      margin: 0 auto;
      word-break: break-all;
      font-size: 14px;
      border: 1px solid #000;
      border-radius: 20px;
      box-sizing: border-box;
    }

    .btn {
      display: inline-block;
      font-size: 14px;
      line-height: 40px;
      color: #e51c23;
      border: 1px solid #e51c23;
      border-radius: 21px;
      padding: 0 20px 0 50px;
      margin-top: 20px;
      cursor: pointer;
      background-image: url('../../../assets/h5/copy.png');
      background-repeat: no-repeat;
      background-size: 20px;
      background-position: 20px center;
    }
  }

  .canvas {
    position: fixed;
    left: 200%;
    top: 200%;
  }

  .poster {
    text-align: center;

    .poster-image {
      width: 60vw;
      margin-bottom: 40px;
    }
  }
}
</style>
